export enum EXISTING_STATUSES {
    PENDING_ACTIVATION = 'pending_activation',
    ACTIVE = 'active',
    DELETED = 'deleted',
}
